<!-- subscription is already active -->
<template>
  <div class="content max-700 m-auto">
    <i18n-t keypath="CreateAolAccount.aolTokenErrors.alreadyActiveSubP1" tag="p" scope="global">
      <template #myAccount>
        <button class="inline-btn-link" @click="logIn">{{ t("Brand.myAccount") }}</button>
      </template>
    </i18n-t>
    <i18n-t keypath="CreateAolAccount.aolTokenErrors.alreadyActiveSubP2" tag="p" scope="global">
      <template #contactAol>
        <button class="inline-btn-link" @click="openAolSupport">{{ tn("contactAol") }}</button>
      </template>
    </i18n-t>
  </div>
</template>

<script setup lang="ts">
import { t } from "@/i18n";
import { openAolSupportPage } from "../AolCreateAccountHelper";
import { getRedirectToLoginURL } from "@/common/loginRedirect";

const baseComponentName = "CreateAolAccount";

function tn(v: string, params?: Record<string, unknown>): string {
  return t(`${baseComponentName}.${v}`, params);
}

function openAolSupport() {
  openAolSupportPage();
}

async function logIn() {
  window.location.href = getRedirectToLoginURL(`${window.location.origin}?aol=true`);
}
</script>
